export default {
  LOCAL: 'local',
  DEV: 'development',
  STAGE: 'staging',
  PROD: 'production',
}
